import { combineReducers } from "redux";
import perusahaanReducer from "./perusahaanReducer";
import akunReducer from "./akunReducer";
import activityReducer from "./activityReducer";
import pegawaiReducer from "./pegawaiReducer";
import daftarAsetReducer from "./daftarAsetReducer";
import anggaranReducer from "./anggaranReducer";
import reportReducer from "./reportReducer";
import chartFilterReducer from "./chartFilter";
import documentReportReducer from "./documentReportReducer";
import rasioKeuanganReducer from "./rasioKeuanganReducer";
import filterKinerja from "./filterKinerja";
import main from "./main";
import chartFilterDashboard from "./chartFilterDashboard";
import filterDashboard from "./filterDashboard";

export default combineReducers({
  perusahaanReducer,
  akunReducer,
  activityReducer,
  pegawaiReducer,
  daftarAsetReducer,
  anggaranReducer,
  reportReducer,
  chartFilterReducer,
  documentReportReducer,
  rasioKeuanganReducer,
  filterKinerja,
  main,
  chartFilterDashboard,
  filterDashboard
});
